import { defineBrowserModule } from "@amtana/browser";
import type { BrowserModule } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import { VAULT_PATH } from "@amtana/vault-client";

import { VAULT_CATALOGS } from "./model/vault-copy.ts";
import { HARNESS_LOGIN_ERROR_COPY, VAULT_ERROR_COPY } from "./model/vault-error-copy.ts";

// The organization's secrets for its agents under Settings (ADR-023 §4), dark behind
// `remote-agents` like the rest of remote agents: the screen is the not-found page and the entry
// is gone while the flag is off, and the doors answer not found.
export const vaultBrowserModule: BrowserModule = defineBrowserModule("vault")
  .withErrorCopy({ ...VAULT_ERROR_COPY, ...HARNESS_LOGIN_ERROR_COPY })
  .withScreens({
    secrets: {
      path: VAULT_PATH,
      title: phrase(VAULT_CATALOGS, "screenTitle"),
      layout: "app",
      flag: "remote-agents",
      load: () => import("./ui/sections/vault-screen.tsx"),
    },
  })
  .withNavigation([
    {
      id: "vault",
      group: "settings-workspace",
      label: phrase(VAULT_CATALOGS, "navSecrets"),
      href: VAULT_PATH,
      icon: "lock",
      order: 875,
      flag: "remote-agents",
    },
  ]);
